import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutGrid, Truck } from 'lucide-react';

/**
 * ViewModeToggle — segmented switch between Dispatcher View (admin schedule)
 * and Field View (employee schedule). Visible only to manager-tier internal staff.
 *
 * The toggle preserves permissions: regular employees/technicians never see it
 * (they don't have access to /admin/schedule anyway), and customers never see it.
 */
const MANAGER_TIER = new Set(['super_admin', 'admin', 'manager', 'service_manager', 'construction_manager', 'office_staff']);

export const ViewModeToggle = ({ userRole }) => {
  const location = useLocation();
  if (!MANAGER_TIER.has(userRole)) return null;

  const isDispatcher = location.pathname.startsWith('/admin/schedule');
  const isField = location.pathname.startsWith('/employee/schedule');

  return (
    <div data-testid="view-mode-toggle" className="flex items-center gap-1 bg-[#141414] border border-[#262626] rounded-md p-1">
      <Link
        to="/admin/schedule"
        data-testid="view-mode-dispatcher"
        data-active={isDispatcher}
        className={`flex items-center gap-1.5 px-3 h-8 rounded text-xs font-medium transition-colors ${
          isDispatcher ? 'bg-[#D4AF37] text-[#0A0A0A]' : 'text-[#A3A3A3] hover:text-white'
        }`}
      >
        <LayoutGrid className="w-3.5 h-3.5" /><span className="hidden sm:inline"> Dispatcher</span>
      </Link>
      <Link
        to="/employee/schedule"
        data-testid="view-mode-field"
        data-active={isField}
        className={`flex items-center gap-1.5 px-3 h-8 rounded text-xs font-medium transition-colors ${
          isField ? 'bg-[#D4AF37] text-[#0A0A0A]' : 'text-[#A3A3A3] hover:text-white'
        }`}
      >
        <Truck className="w-3.5 h-3.5" /><span className="hidden sm:inline"> Field</span>
      </Link>
    </div>
  );
};

export default ViewModeToggle;
